module.exports = __webpack_public_path__ + "img/bg1.b8c5717e.webp";